import CardTitleWithIcon from "@/components/company/card-title-with-icon";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useTranslation } from "@/hooks/useTranslation";
import { CompanyDTO } from "@shaarp/common";
import { BuildingIcon, SwordsIcon } from "lucide-react";

type CardCompanyCompetitorsProps = {
  company: CompanyDTO;
};

export default function CardCompanyCompetitors({
  company,
}: CardCompanyCompetitorsProps) {
  const { t } = useTranslation();

  if (company.competitors.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitleWithIcon icon={SwordsIcon} title={t("company.insights.competitors.title")} />
      </CardHeader>
      <CardContent className="flex flex-col">
        {company.competitors.map((competitor, i) => (
          <div
            key={competitor}
            className={`flex items-center gap-3 py-3 -mx-6 px-6 ${i > 0 ? "border-t" : ""}`}
          >
            <BuildingIcon className="w-4 h-4 text-muted-foreground shrink-0" />
            <span className="text-sm font-medium">{competitor}</span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
